import styled from "styled-components";

export const GameDurationBox = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 1.1rem;
`